// extracted by mini-css-extract-plugin
module.exports = {"commentsContainer":"PreDisbursementViewComments_commentsContainer__3SKGg"};